// The member role picker in the teams settings panel.
//
// A custom trigger + listbox rather than a native `<select>`, matching
// `ProjectStatusSelect` and `SortSelect`. The native control renders the
// operating system's own dropdown, which on macOS is an opaque grey panel in
// the system font -- inside a dark settings modal it reads as a browser
// artifact rather than part of the product, and it was the only such control
// in the panel.
//
// The behaviour now lives in `ListboxSelect`, which the allowance control uses
// too. It was extracted rather than copied for exactly the reason this file
// exists: a second hand-rolled dropdown is a second chance to drift back to a
// native select. The test ids and the right-aligned menu are preserved, so this
// renders identically to before.

import type { TeamRole } from '../../api/teams'
import ListboxSelect from './ListboxSelect'

export default function RoleSelect({
  memberId,
  ariaLabel,
  value,
  options,
  disabled,
  labelFor,
  onSelect,
}: {
  memberId: string
  ariaLabel: string
  value: TeamRole
  /** Roles the actor may assign. Never includes `owner` — see permissions.ts. */
  options: TeamRole[]
  disabled: boolean
  labelFor: (role: TeamRole) => string
  onSelect: (role: TeamRole) => void
}) {
  return (
    <ListboxSelect
      ariaLabel={ariaLabel}
      value={value}
      options={options}
      disabled={disabled}
      labelFor={labelFor}
      onSelect={onSelect}
      triggerTestId={`teams-member-role-${memberId}`}
      menuTestId={`teams-member-role-menu-${memberId}`}
      optionTestId={(role) => `teams-member-role-option-${memberId}-${role}`}
    />
  )
}
